import React, { useCallback, useLayoutEffect, useRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Container, Row, Col } from "react-bootstrap";

import "./styles.scss";

const Body = ({ children, className }) => {
  const ref = useRef(null);
  const rootStyle = document.documentElement.style;
  const parentElement = document.getElementById("myDpdMainContainer");
  const bannerContainer = document.getElementById("bannerAbsoluteContainer");
  const getProperty = useCallback(
    property => parseInt(rootStyle.getPropertyValue(property)),
    [rootStyle]
  );
  const setProperty = useCallback(
    (property, value) => rootStyle.setProperty(property, `${value}px`),
    [rootStyle]
  );

  useLayoutEffect(() => {
    const element = ref.current;
    // Define the Main top position and if the Main body has a scroll
    // read the actual value, not a memoised one
    // and apply it only if the Top position or Scroll width are changed
    function updateSize() {
      const currentTopPosition = parentElement?.offsetTop || 0;
      const previousTopPosition = getProperty("--content-position-top");
      previousTopPosition !== currentTopPosition &&
        setProperty("--content-position-top", currentTopPosition);

      const currentScrollWidth =
        element?.clientHeight < element?.scrollHeight
          ? document.documentElement.clientWidth - element.clientWidth
          : 0;
      const previousScrollWidth = getProperty("--content-scroll-width");
      previousScrollWidth !== currentScrollWidth &&
        setProperty("--content-scroll-width", currentScrollWidth);

      const currentTopPadding = bannerContainer?.clientHeight || 0;
      const previousTopPadding = getProperty("--content-main-padding-top");
      previousTopPadding !== currentTopPadding &&
        setProperty("--content-main-padding-top", currentTopPadding);
    }

    try {
      new ResizeObserver(updateSize).observe(element);
      new ResizeObserver(updateSize).observe(bannerContainer);
    } catch (e) {
      // Chrome <64 and IE doesn't support the Observer, so the Banner's position is static
    }
    updateSize();
  }, [getProperty, setProperty, bannerContainer, parentElement]);

  return (
    <Row
      ref={ref}
      id="myDpdMainBody"
      className={classNames(
        "mydpd-main-body m-0 flex-grow-1 overflow-auto",
        className
      )}
    >
      <Col>
        <Container>{children}</Container>
      </Col>
    </Row>
  );
};

Body.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Body;
